import React from 'react';

const LoginContainer = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center p-5 bg-gray-50">
    <div className="relative overflow-hidden rounded-[32px] p-[2px] shadow-[10px_10px_20px_rgba(0,0,0,0.08),-10px_-10px_20px_rgba(255,255,255,0.85)] transition-all duration-300 hover:-translate-y-0.5 w-full max-w-md">
      <div className="absolute inset-0 bg-gradient-to-br from-neutral-300/60 via-neutral-100/35 to-transparent opacity-60" />
      <div className="relative h-full w-full rounded-[28px] bg-white border border-gray-200 shadow-[inset_8px_8px_16px_rgba(0,0,0,0.04),inset_-8px_-8px_16px_rgba(255,255,255,0.9)] px-8 py-10">
        {children}
      </div>
    </div>
  </div>
);

export default LoginContainer;
